(() => {
  const STORAGE_KEY = 'productDataCompare';
  const MAX_ITEMS = 4;
  const strings = () => window.techticCompareStrings || {};

  function cleanItem(id, handle) {
    const cleanId = String(id || '').trim();
    const cleanHandle = String(handle || '')
      .trim()
      .replace(/^.*\/products\//, '')
      .split(/[?#]/)[0];

    if (!cleanId || !cleanHandle || cleanHandle === 'undefined' || cleanHandle === 'null') return null;
    return { id: cleanId, handle: cleanHandle };
  }

  function readItems() {
    let parsed;
    try {
      parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
      localStorage.removeItem(STORAGE_KEY);
      parsed = {};
    }

    const items = [];
    if (Array.isArray(parsed)) {
      parsed.forEach((item, index) => {
        const value = typeof item === 'string'
          ? cleanItem(index, item)
          : cleanItem(item && (item.id || item.product_id || index), item && (item.handle || item.value));
        if (value) items.push(value);
      });
    } else if (parsed && typeof parsed === 'object') {
      Object.entries(parsed).forEach(([id, value]) => {
        const item = typeof value === 'string'
          ? cleanItem(id, value)
          : cleanItem(value && (value.id || id), value && (value.handle || value.value));
        if (item) items.push(item);
      });
    }

    const unique = new Map();
    items.forEach((item) => unique.set(item.id, item));
    return Array.from(unique.values()).slice(0, MAX_ITEMS);
  }

  function writeItems(items, target) {
    const data = {};
    items.slice(0, MAX_ITEMS).forEach((item) => {
      data[item.id] = item.handle;
    });

    if (Object.keys(data).length) localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    else localStorage.removeItem(STORAGE_KEY);
    refresh(target);
    window.dispatchEvent(new CustomEvent('compareIdChanged'));
    window.dispatchEvent(new CustomEvent('compareUpdated', { detail: { target } }));
  }

  function updateButtons(items) {
    const selectedIds = new Set(items.map((item) => item.id));
    document.querySelectorAll('compare-button[data-id]').forEach((button) => {
      const active = selectedIds.has(String(button.dataset.id));
      const label = active
        ? button.dataset.textActive || strings().remove || 'Remove from compare'
        : button.dataset.text || strings().add || 'Add to compare';

      button.classList.toggle('active', active);
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function updateBubbles(count) {
    document.querySelectorAll('compare-bubble').forEach((bubble) => {
      if (bubble.firstElementChild) bubble.firstElementChild.textContent = count ? String(count) : '';
      bubble.setAttribute('aria-label', `${strings().compare || 'Compare'}: ${count}`);
    });
  }

  function ensureTray() {
    let tray = document.querySelector('[data-tt-compare-tray]');
    if (tray) return tray;

    tray = document.createElement('aside');
    tray.className = 'tt-compare-tray';
    tray.hidden = true;
    tray.setAttribute('data-tt-compare-tray', '');
    tray.setAttribute('aria-live', 'polite');
    tray.innerHTML = `
      <div class="tt-compare-tray__summary">
        <strong data-tt-compare-tray-count></strong>
        <span>${strings().selected || 'selected'}</span>
      </div>
      <div class="tt-compare-tray__actions">
        <button type="button" class="tt-compare-tray__clear" data-tt-compare-clear>${strings().clear || 'Clear'}</button>
        <a class="tt-compare-tray__link" href="/pages/compare">${strings().compareNow || 'Compare now'}</a>
      </div>`;
    document.body.appendChild(tray);
    return tray;
  }

  function updateTray(items) {
    const tray = ensureTray();
    const count = items.length;
    const isComparePage = window.location.pathname.replace(/\/$/, '') === '/pages/compare';
    const shouldShow = count > 0 && !isComparePage;
    const counter = tray.querySelector('[data-tt-compare-tray-count]');
    if (counter) counter.textContent = `${count} / ${MAX_ITEMS}`;
    tray.hidden = !shouldShow;
    tray.classList.toggle('is-visible', shouldShow);
  }

  function refresh(target) {
    const items = readItems();
    updateButtons(items);
    updateBubbles(items.length);
    updateTray(items);
    window.dispatchEvent(new CustomEvent('techticCompareUpdated', { detail: { items, target } }));
  }

  document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-tt-compare-clear]');
    if (clearButton) {
      event.preventDefault();
      writeItems([], clearButton);
      return;
    }

    const removeButton = event.target.closest('[data-tt-compare-remove]');
    if (removeButton) {
      event.preventDefault();
      const id = String(removeButton.dataset.ttCompareRemove || '');
      writeItems(readItems().filter((item) => item.id !== id), removeButton);
      return;
    }

    const compareButton = event.target.closest('compare-button[data-id]');
    if (!compareButton || compareButton.classList.contains('delete-item-button')) return;
    const item = cleanItem(compareButton.dataset.id, compareButton.dataset.productHandle);
    const items = readItems();
    const isSelected = item && items.some((current) => current.id === item.id);
    if (!item || isSelected || items.length < MAX_ITEMS) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const tray = ensureTray();
    tray.classList.add('is-limit');
    window.setTimeout(() => tray.classList.remove('is-limit'), 900);
  }, true);

  document.addEventListener('keydown', (event) => {
    const compareButton = event.target.closest('compare-button[data-id]');
    if (!compareButton || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    compareButton.click();
  }, true);

  window.addEventListener('compareUpdated', (event) => {
    refresh(event.detail && event.detail.target);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) refresh();
  });

  const observer = new MutationObserver(() => updateButtons(readItems()));
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.TechTicCompare = { maxItems: MAX_ITEMS, readItems, writeItems, refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  } else {
    refresh();
  }
})();
